import React from "react";
import SimpleCrudPage from "@/components/SimpleCrudPage";
import { apiListBahan, apiCreateBahan, apiUpdateBahan } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const rupiah = (n) => "Rp" + Number(n || 0).toLocaleString("id-ID");
const FIELDS = [
  // owner 2026-10-16: empty = automatic code (BHN-0001); never the code of a barang (checked by the server)
  { key: "kode", label: "Kode", immutable: true, placeholder: "kosong = otomatis (BHN-0001)" },
  { key: "nama", label: "Jenis / nama bahan", required: true },
  { key: "satuan", label: "Satuan", required: true },
  { key: "harga_beli", label: "Harga beli", type: "number", required: true, format: rupiah },
];
const API = { list: apiListBahan, create: apiCreateBahan, update: apiUpdateBahan };

export default function BahanManagement() {
  const { user } = useAuth();  // owner 2026-10-12: the Manager sees bahan with prices, changes nothing
  return (
    <SimpleCrudPage testId="bahan" title="Master Bahan" fields={FIELDS} api={API} rowKey={(r) => r.kode} lihatSaja={user?.role === "manager"}
      subtitle="Bahan baku produksi. Stok dicatat lewat pembelian dan pemakaian (tahap berikutnya), bukan diubah langsung. Kode bahan tidak boleh sama dengan kode barang." />
  );
}
